import React from 'react';
import { Spin } from 'antd';
import { PW } from '../theme/tokens';

/** 라우트 lazy 청크 로딩 중 표시 (P4-3) */
const RouteFallback: React.FC = () => (
  <div
    style={{
      minHeight: '40vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: PW.color.canvas,
    }}
    aria-busy="true"
    aria-live="polite"
  >
    <Spin size="large" tip="페이지를 불러오는 중…" />
  </div>
);

export default RouteFallback;
